import { ReplyIcon } from '@heroicons/react/outline';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { defaultAuth } from '../../atoms/auth';
import { Avatar } from '../../widgets';
import { TargetItem } from '../../types';
dayjs.extend(utc);
dayjs.extend(timezone);

const PopupParent = ({
  props,
  target,
}: {
  props: { desc: string; created_at: string; customer: { name: string } };
  target: Omit<TargetItem, '_id' | 'product_id'>;
}): JSX.Element => {
  return (
    <div className="flex space-x-3 items-start">
      <div className="w-10 h-10">
        <Avatar title={props.customer.name} />
      </div>
      <div className="flex flex-1 flex-col space-y-1">
        <div className="space-x-2 flex justify-between items-center">
          <span className="font-medium text-gray-900 text-sm">
            {props.customer.name}
          </span>
          <span className="text-gray-500 text-xs">
            {dayjs.utc(props.created_at).format('DD/MM/YYYY HH:mm')}
          </span>
        </div>
        <p className="text-gray-700 text-sm line-clamp-2">{props.desc}</p>
        <div className="flex items-start space-x-1">
          <span className="w-4 h-4 flex">
            <ReplyIcon className="w-full h-full rotate-180 text-gray-400" />
          </span>
          <a
            href={`${defaultAuth?.myharavan_domain}/products/${target.handle}`}
            target="_blank"
            rel="noreferrer"
            className="text-sm line-clamp-2 text-blue-700"
            title={target.title}
          >
            {target.title}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PopupParent;
